import styles from './Avatar.module.scss';

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface AvatarProps {
  src?: string;
  username: string;
  size?: AvatarSize | number | string;
  onClick?: () => void;
  className?: string;
}

const sizeClassMap: Record<AvatarSize, string> = {
  xs: styles.sizeXs,
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
  xl: styles.sizeXl,
};

export default function Avatar({
  src,
  username,
  size = 'md',
  onClick,
  className,
}: AvatarProps) {
  const imgSrc = src
    ? src
    : `https://ui-avatars.com/api/?name=${encodeURIComponent(username)}`;

  const isNamedSize = typeof size === 'string' && size in sizeClassMap;

  const classNames = [
    styles.avatar,
    isNamedSize ? sizeClassMap[size as AvatarSize] : undefined,
    onClick ? styles.clickable : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Named sizes use CSS classes backed by design tokens; custom values use inline styles
  const inlineStyle = isNamedSize
    ? undefined
    : { width: typeof size === 'number' ? `${size}px` : size, height: typeof size === 'number' ? `${size}px` : size };

  return (
    <img
      src={imgSrc}
      alt={username}
      className={classNames}
      style={inlineStyle}
      onClick={onClick}
    />
  );
}
